import { useTranslation } from "react-i18next";
import { InputTextStyled, SelectStyled } from "../../../../../../style/Input";
import { FormRow } from "../../../../../../style/form";
import { ManagePracticeRequestFormModel } from "./ManagePracticeRequestFormModel";
import { RowSpacer } from "../../../../../../style/containers";
import { useMemo } from "react";
import { SelectPair } from "../../../../../../types/common.types";
import { Input } from "antd";
import styled from "styled-components";

const ManagePracticeRequestFormWrapper = styled.div`
  div.message-text {
    height: 200px;
    min-height: 50%;
    margin: 5px auto;
    text-align: left;
    position: relative;
    display: flex;
    flex-direction: column;

    textarea.message-text {
      flex-grow: 1;
      width: 100%;
      box-sizing: border-box;
      margin: 5px auto;
      padding: 5px;
      text-align: left;
      position: relative;
    }
  }
`;

interface IManagePracticeRequestFormProps {
  model: ManagePracticeRequestFormModel;
  toList: number[];
  onChange: (value: any, field: string) => void;
}

const ManagePracticeRequestForm = ({
  model,
  toList,
  onChange,
}: IManagePracticeRequestFormProps) => {
  const { t } = useTranslation();

  const toOptions = useMemo(() => {
    const result: SelectPair[] = [];

    if (toList.length === 1)
      result.push({
        value: toList[0].toString(),
        label: t(`practice-request-user-profile-description-${toList[0]}`),
      });
    else {
      result.push({
        value: "",
        label: "",
      });

      toList!.forEach((to) => {
        result.push({
          value: to.toString(),
          label: t(`practice-request-user-profile-description-${to}`),
        });
      });
    }

    return result;
  }, [toList]);

  const priorityOptions = useMemo(
    () => [
      {
        value: "NU",
        label: t("practice-request-priority-description-NU"),
      },
      {
        value: "U",
        label: t("practice-request-priority-description-U"),
      },
    ],
    []
  );

  return (
    <ManagePracticeRequestFormWrapper>
      <FormRow>
        <SelectStyled
          label={t("new-request-form-to-label")}
          onChange={(to) => onChange(to, "to")}
          value={model.to}
          options={toOptions}
        />

        <RowSpacer />

        <SelectStyled
          label={t("new-request-form-priority-label")}
          onChange={(priority) => onChange(priority, "priority")}
          value={model.priority}
          options={priorityOptions}
          disabled={true}
        />
      </FormRow>

      <FormRow>
        <InputTextStyled
          label={`${t("new-request-form-object-label")} *`}
          onChange={(object) => onChange(object, "object")}
          value={model.object}
          disabled={true}
        />
      </FormRow>

      <FormRow className="message-text">
        <Input.TextArea
          onChange={(e) => onChange(e.target.value, "text")}
          value={model.text ?? ""}
          className="message-text"
          placeholder={
            t("appraisals-details-tab-requests-new-request-text-placeholder")!
          }
        />
      </FormRow>
    </ManagePracticeRequestFormWrapper>
  );
};

export default ManagePracticeRequestForm;
